// DS: C33C
/** Bottom section of a commission, containing related information
 *  https://zpl.io/2pvJMnN
 */
import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { getDeviationTitle } from '../../../_helpers';
import Flex from '../../../../Flex';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import UserLink from '../../../../User/Link';
import UserAvatar from '../../../../User/Avatar';
import Timestamp from '../../../../Timestamp';
import PriceBlock from './PriceBlock';
import s from './PanelC33C.scss';
var PanelC33C = function (_a) {
    var deviation = _a.deviation, _b = _a.showAuthor, showAuthor = _b === void 0 ? true : _b, _c = _a.showTimestamp, showTimestamp = _c === void 0 ? true : _c, addLink = _a.addLink, className = _a.className, priceProps = __rest(_a, ["deviation", "showAuthor", "showTimestamp", "addLink", "className"]);
    var hasAuthor = deviation.author && showAuthor;
    var title = addLink ? (React.createElement(DeviationLink, { deviation: deviation, className: classnames(s['title'], s['nowrap']) }, getDeviationTitle(deviation))) : (React.createElement("div", { className: classnames(s['title'], s['nowrap']), title: getDeviationTitle(deviation) }, getDeviationTitle(deviation)));
    return (React.createElement(Flex, { className: classnames(s['root'], className), alignItems: "center" },
        React.createElement("div", { className: s['left'] },
            title,
            React.createElement(Flex, { alignItems: "center", className: classnames(s['author-block'], hasAuthor && s['has-author']) },
                hasAuthor && (React.createElement(React.Fragment, null,
                    React.createElement(UserAvatar, { size: 24, className: s['avatar'], user: deviation.author }),
                    React.createElement(UserLink, { user: deviation.author, className: classnames(s['userlink'], s['nowrap']) }))),
                showTimestamp && (React.createElement(Timestamp, { timestamp: deviation.publishedTime, className: classnames(s['timestamp'], s['nowrap']) })))),
        React.createElement(PriceBlock, __assign({}, priceProps))));
};
PanelC33C.displayName = 'PanelC33C';
export default PanelC33C;
//# sourceMappingURL=PanelC33C.js.map